const colorMap = new Map([
    ['Beige', ['#EAD8AB', false]],
    ['Black', ['#000000', false]],
    ['Blue', ['#005BD3', false]],
    ['Bronze', ['#CD7F32', false]],
    ['Brown', ['#A52A2A', false]],
    ['Burgundy', ['#4D1224', false]],
    ['Cream', ['#E9D4AE', false]],

    ['Multicolor', ['https://cdn.shopify.com/s/files/1/0894/0552/2219/files/multicolor.png?v=1769070789&width=50', true]],

    ['Gold', ['#D49A06', false]],
    ['Green', ['#05AA3D', false]],
    ['Grey', ['#808080', false]],
    ['Maroon', ['#800000', false]],
    ['Metallic', ['#BCC6CC', false]],
    ['Navy', ['#282099', false]],
    ['Orange', ['#FF8A00', false]],
    ['Peach', ['#D4B7B7', false]],
    ['Pink', ['#FFC0CB', false]],
    ['Purple', ['#A54DCF', false]],
    ['Red', ['#F61F1F', false]],
    ['Silver', ['#D3D3D3', false]],
    ['White', ['#FFFFFF', false]],
    ['Yellow', ['#FFE500', false]],

    ['Sultan', ['#E8A066', false]],
    ['Dark Black', ['#000000', false]],
    ['Velvet', ['#750851', false]],
    ['Pastel', ['#B3EBF2', false]],
    ['Emerald', ['#50C878', false]],
    ['coral', ['#FF7F50', false]],
    ['Clear', ['#FFFFFF', false]],
    ['cherry', ['#D20A2E', false]],
    ['Champagne', ['#F7E7CE', false]],
    ['Mehendi Green', ['#31514B', false]],
    ['Indigo', ['#4B0082', false]],
    ['Violet', ['#3B6283', false]],
    ['Turquoise', ['#7BF9FF', false]],
    ['Teal Blue', ['#1C5169', false]],
    ['Pistachio', ['#93C572', false]],
    ['Peacock', ['#006994', false]],
    ['Teal', ['#008080', false]],
    ['Charcoal Grey', ['#808080', false]],
    ['Nude', ['#E3BC9A', false]],
    ['Tan', ['#D2B48C', false]],
    ['Sage Green', ['#B2AC88', false]],
    ['Lemon Yellow', ['#FFF44F', false]],
    ['Sky Blue', ['#00B5E2', false]],
    ['Light-Blue', ['#90D5FF', false]],
    ['Rose gold', ['#B76F79', false]],
    ['Lavender', ['#F6B4FF', false]],
    ['Magenta', ['#FD3DB5', false]],
    ['Sea Green', ['#2E8B57', false]],
    ['Olive', ['#808000', false]],

    ['Light Brown', ['#C4A484', false]],
    ['Dark Brown', ['#654321', false]],
    ['coffee Brown', ['#6F4E37', false]],
    ['Camel Brown', ['#C19A6B', false]],
    ['Dark Green', ['#006400', false]],
    ['Light Green', ['#90EE90', false]],
    ['Rama Green', ['#008080', false]],
    ['Rust', ['#B7410E', false]],
    ['Fuchsia Pink', ['#FF00FF', false]],
    ['Copper', ['#B87333', false]],
    ['Khaki', ['#F0E68C', false]],
    ['Off White', ['#FFFFE2', false]],
    ['Mustard', ['#FFDB58', false]],
    ['Teal Green', ['#006D5B', false]],
    ['Geometric',["https://cdn.shopify.com/s/files/1/0894/0552/2219/files/geometric.png?v=1769081967&width=50",true]],
    ['Floral',["https://cdn.shopify.com/s/files/1/0894/0552/2219/files/floral.png?v=1769082211&width=50",true]],
    ['Striped',["https://cdn.shopify.com/s/files/1/0894/0552/2219/files/striped.png?v=1769081453&width=50",true]]
]);

function findHaxCode(key) {
    if (colorMap.has(key)) {
        return colorMap.get(key);
    }
    return [key, false];
}

window.onWizzyScriptLoaded = function () {
    function applyMobileFilterConfig(data) {
        if (data.search && data.search.configs) {
            if (data.search.configs.pagination) {
                data.search.configs.pagination.appendInExistingList = true;
            }
            if (data.search.configs.facets) {
                data.search.configs.facets.showPriceInputRangeFields = true;
            }
            var facetConfigs = data.search.configs.facets && data.search.configs.facets.configs;
            if (facetConfigs && facetConfigs.forEach) {
                facetConfigs.forEach(function (facetConfig) {
                    if (facetConfig.key === "discountPercentage") {
                        facetConfig.config = { interval: 10 };
                    }
                });
            }
        }
        if (data.filters && data.filters.configs) {
            data.filters.configs.keepOpenedInMobileAfterApply = true;
        }
        return data;
    }

    var renderResultEvent = window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS || window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULT;
    if (renderResultEvent) {
        window.wizzyConfig.events.registerEvent(renderResultEvent, function (data) {
            var facets = data && data.response && data.response.payload && data.response.payload.facets;
            if (!facets && data) facets = data.facets;
            if (facets && facets.forEach) {
                facets.forEach(function (facet) {
                    if (!facet || facet.key !== "colors" || !facet.data || !facet.data.forEach) return;
                    facet.data.forEach(function (item) {
                        if (!item.data) item.data = {};
                        if (!colorMap.has(item.key)) {
                            item.data.swatch = null;
                            return;
                        }
                        var color = findHaxCode(item.key);
                        item.data.swatch = { type: "visual", value: color[0] };
                    });
                });
            }
            return data;
        });
    }
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, applyMobileFilterConfig);
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, applyMobileFilterConfig);

    function resolveAutocompleteProductTotal(data) {
        if (!data) return null;
        if (data.totalProducts != null) return data.totalProducts;
        if (data.total != null) return data.total;
        if (data.payload && data.payload.products && data.payload.products.total != null) {
            return data.payload.products.total;
        }
        var payload = data.data && data.data.response && data.data.response.payload;
        if (payload && payload.products && payload.products.total != null) return payload.products.total;
        if (payload && payload.total != null) return payload.total;
        return null;
    }

    function updateAutocompleteViewAllCount(data) {
        var buttons = document.querySelectorAll(".wizzy-autocomplete-top-products-view-more");
        if (!buttons.length) return;
        var totalResults = resolveAutocompleteProductTotal(data);
        if (totalResults == null) return;
        var label = "View all (" + totalResults + ") products";
        buttons.forEach(function (button) {
            button.textContent = label;
        });
    }

    function syncAutocompleteViewAllButton(data) {
        var topBlock = document.querySelector(".wizzy-autocomplete-wrapper .wizzy-autocomplete-top-products");
        if (!topBlock) return;
        var hasProducts = topBlock.querySelector(".topproduct-item");
        var viewMoreWrap = topBlock.querySelector(".autocomplete-top-products-view-more");
        if (!hasProducts) {
            if (viewMoreWrap) viewMoreWrap.style.display = "none";
            return;
        }
        if (!viewMoreWrap) {
            viewMoreWrap = document.createElement("div");
            viewMoreWrap.className = "autocomplete-top-products-view-more";
            viewMoreWrap.innerHTML =
                '<button type="button" class="btn btn--small wizzy-autocomplete-top-products-view-more">View More</button>';
            topBlock.appendChild(viewMoreWrap);
        }
        viewMoreWrap.style.display = "flex";
        viewMoreWrap.style.visibility = "visible";
        updateAutocompleteViewAllCount(data);
    }

    var autocompleteProductsEvent = window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER;
    if (autocompleteProductsEvent) {
        window.wizzyConfig.events.registerEvent(autocompleteProductsEvent, function (data) {
            if (data && resolveAutocompleteProductTotal(data) != null) {
                window._wizzyLastAutocompleteTotal = resolveAutocompleteProductTotal(data);
            }
            return data;
        });
    }

    var autocompleteWrapperEvent = window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_WRAPPER_RENDER;
    if (autocompleteWrapperEvent) {
        window.wizzyConfig.events.registerEvent(autocompleteWrapperEvent, function (data) {
            if (resolveAutocompleteProductTotal(data) != null) {
                window._wizzyLastAutocompleteTotal = resolveAutocompleteProductTotal(data);
            }
            window.setTimeout(function () {
                var payload = data || {};
                if (payload.totalProducts == null && window._wizzyLastAutocompleteTotal != null) {
                    payload.totalProducts = window._wizzyLastAutocompleteTotal;
                }
                syncAutocompleteViewAllButton(payload);
                if (window._wizzyAutocompleteForceClosed) closeSearchAutocomplete();
                else syncAutocompleteWidth();
            }, 100);
            return data;
        });
    }
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED, function (data) {
        data.attributeFacetValuesLimit = 250;
        return data;
    });
    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function (data) {
        data.attributeFacetValuesLimit = 250;
        closeSearchAutocomplete();
        window.setTimeout(closeSearchAutocomplete, 0);
        window.setTimeout(closeSearchAutocomplete, 200);
        document.querySelectorAll('.prasha-collection-titlebar').forEach(function (element) {
            element.remove();
        });
        if (document.getElementById("wizzy-shopify-collection-page-wrapper") && data && String(data.q || "").trim()) {
            document.documentElement.classList.add("wizzy-collection-query");
            if (document.body) document.body.classList.add("wizzy-collection-query");
        }
        return data;
    });
    if (!window._wizzyCollectionQueryPop) {
        window._wizzyCollectionQueryPop = true;
        window.addEventListener("popstate", function () {
            var path = window.location.pathname || "";
            if (path.indexOf("/collections/") !== -1 && path.indexOf("/search") === -1) {
                document.documentElement.classList.remove("wizzy-collection-query");
                if (document.body) document.body.classList.remove("wizzy-collection-query");
            }
        });
    }
    var productsCachedEvent = window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED;
    if (productsCachedEvent) {
        window.wizzyConfig.events.registerEvent(productsCachedEvent, function (data) {
            syncAutocompleteViewAllButton(data);
            return data;
        });
    }

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, function (data) {
        syncAutocompleteViewAllButton(data);
        if (window._wizzyAutocompleteForceClosed) closeSearchAutocomplete();
        bindWizzyMobileFilterBehaviour();
        syncWizzyFilterHeaderTitle();
        syncWizzyPriceInputs();
        placeWizzyDesktopAppliedFilters();
        cleanWizzyAppliedFilters();
        if (window.innerWidth > 768) restoreWizzyMobileSort();
        else if (wizzyMobileOverlayOpen()) enhanceWizzyMobileDrawer();
        return data;
    });
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
        function (products) {
            if (!products || !products.forEach) return products;
            products.forEach(product => {
                var brand = "";
                (product.attributes || []).forEach(attr => {
                    var value = attr.values && attr.values[0] && attr.values[0].value && attr.values[0].value[0];
                    if (attr.id === "product_offer_text_pra" && value) {
                        product.offerText = value;
                    }
                    var id = String(attr.id || "").toLowerCase();
                    if (!brand && value && (id === "product_brand_custom" || id === "product_vendor" || id === "vendor" || id === "brand")) {
                        brand = value;
                    }
                });
                if (!brand && product.vendor) brand = product.vendor;
                if (!brand && product.brands && product.brands.length) {
                    var brandEntry = product.brands[0];
                    brand = typeof brandEntry === "string" ? brandEntry : (brandEntry.value || brandEntry.label || brandEntry.name || "");
                }
                if (brand) {
                    product.actualBrand = String(brand);
                    product.actualBrandQuery = encodeURIComponent(product.actualBrand);
                }

                var sizeValues = product.swatches && product.swatches.sizes && product.swatches.sizes.values;
                product.swatchSizes = (sizeValues || []).map(function (item) {
                    return {
                        label: item.value || (item.swatch && item.swatch.value),
                        inStock: item.inStock
                    };
                });
                product.hasSwatchSizes = product.swatchSizes.length > 0;
                if (product.sellingPrice != null && product.sellingPrice !== "") {
                    product.sellingPrice = String(product.sellingPrice).replace(/(\d[\d,]*)\.\d+/g, "$1");
                }
                if (product.price != null && product.price !== "") {
                    product.price = String(product.price).replace(/(\d[\d,]*)\.\d+/g, "$1");
                }
            });

            return products;
        }
    );
};

var WIZZY_MOBILE_FILTER_MAX = 768;
var WIZZY_ARROW_SVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow" viewBox="0 0 14 10" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"/></svg>';
var WIZZY_CLOSE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17" aria-hidden="true"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"/></svg>';

function wizzyMobileFilterViewport() {
    return window.innerWidth <= WIZZY_MOBILE_FILTER_MAX;
}

function wizzyMobileOverlayOpen() {
    return !!document.querySelector(".wizzy-overlay-opened.wizzy-filters-overlay");
}

function getWizzyFilterPanel() {
    return document.querySelector(".wizzy-search-wrapper .wizzy-search-filters-left");
}

var wizzySelectedFiltersHome = null;

function getWizzySelectedFilters() {
    var blocks = document.querySelectorAll(".wizzy-search-wrapper .wizzy-selected-filters");
    for (var i = 0; i < blocks.length; i++) {
        if (blocks[i].closest("[data-wizzy-mobile-applied-filters]")) continue;
        if (blocks[i].querySelector(".wizzy-selected-facet-list-item")) return blocks[i];
    }
    return null;
}

function ensureWizzyDesktopAppliedSlot(filtersLeft) {
    var wrapper = filtersLeft.querySelector(".wizzy-search-filters-left-wrapper") || filtersLeft;
    var slot = wrapper.querySelector("[data-wizzy-desktop-applied]");
    if (!slot) {
        slot = document.createElement("div");
        slot.className = "wizzy-desktop-applied-filters";
        slot.setAttribute("data-wizzy-desktop-applied", "");
        var header = wrapper.querySelector(".wizzy-filters-header");
        if (header) header.insertAdjacentElement("afterend", slot);
        else wrapper.insertBefore(slot, wrapper.firstChild);
    }
    return slot;
}

function restoreWizzySelectedFilters() {
    var selected = document.querySelector(".wizzy-search-wrapper [data-wizzy-desktop-applied] .wizzy-selected-filters");
    var slot = document.querySelector(".wizzy-search-wrapper [data-wizzy-desktop-applied]");
    if (selected) {
        selected.querySelectorAll(".wizzy-desktop-pill-remove").forEach(function (node) {
            node.remove();
        });
        var home = wizzySelectedFiltersHome;
        if (home && home.parent && home.parent.isConnected && !home.parent.closest(".wizzy-search-filters-left")) {
            if (home.next && home.next.parentNode === home.parent) home.parent.insertBefore(selected, home.next);
            else home.parent.appendChild(selected);
        } else {
            var top = document.querySelector(".wizzy-search-wrapper .wizzy-search-filters-top");
            if (top) top.appendChild(selected);
        }
    }
    wizzySelectedFiltersHome = null;
    if (slot) slot.remove();
    document.querySelectorAll(".wizzy-search-filters-left .wizzy-filters-clear-all.wizzy-desktop-clear-visible").forEach(function (clear) {
        clear.classList.remove("wizzy-desktop-clear-visible");
    });
}

function syncWizzyDesktopPillRemove(selected) {
    selected.querySelectorAll(".wizzy-selected-facet-list-item").forEach(function (item) {
        if (item.querySelector(".wizzy-desktop-pill-remove")) return;
        var mark = document.createElement("span");
        mark.className = "wizzy-desktop-pill-remove";
        mark.setAttribute("aria-hidden", "true");
        mark.textContent = "\u00d7";
        item.appendChild(mark);
    });
}

function bindWizzyDesktopPillRemove() {
    if (window._wizzyDesktopPillRemove) return;
    window._wizzyDesktopPillRemove = true;
    document.addEventListener("click", function (e) {
        if (window.innerWidth <= 768) return;
        var slot = e.target.closest && e.target.closest("[data-wizzy-desktop-applied]");
        if (!slot) return;
        var item = e.target.closest(".wizzy-selected-facet-list-item");
        if (!item || !slot.contains(item)) return;
        if (e.target.closest(".wizzy-desktop-pill-remove")) return;
        e.stopPropagation();
    }, true);
}

function placeWizzyMobileAppliedFilters() {
    var wrapper = document.querySelector(".wizzy-search-wrapper");
    if (!wrapper) return;
    var host = wrapper.querySelector("[data-wizzy-mobile-applied-filters]");
    if (!host) {
        host = document.createElement("div");
        host.className = "wizzy-mobile-applied-filters";
        host.setAttribute("data-wizzy-mobile-applied-filters", "");
    }
    var results = wrapper.querySelector(".wizzy-search-results");
    if (results && host.nextElementSibling !== results) results.insertAdjacentElement("beforebegin", host);
    var selected = getWizzySelectedFilters();
    host.replaceChildren();
    if (!selected) {
        host.hidden = true;
        return;
    }
    host.hidden = false;
    host.appendChild(selected.cloneNode(true));
    var removeAll = host.querySelector(".wizzy-filters-clear-all");
    if (!removeAll) {
        var clear = wrapper.querySelector(".wizzy-search-filters-left .wizzy-filters-clear-all, .wizzy-search-filters-top .wizzy-filters-clear-all");
        if (clear && !clear.closest("[data-wizzy-mobile-applied-filters]")) {
            removeAll = clear.cloneNode(true);
            removeAll.textContent = "Remove all";
        }
    }
    var list = host.querySelector(".wizzy-selected-facet-list");
    if (removeAll && list) list.appendChild(removeAll);
}

function placeWizzyDesktopAppliedFilters() {
    if (window.innerWidth <= 768) {
        restoreWizzySelectedFilters();
        placeWizzyMobileAppliedFilters();
        return;
    }
    var mobileHost = document.querySelector(".wizzy-search-wrapper [data-wizzy-mobile-applied-filters]");
    if (mobileHost) mobileHost.remove();
    var filtersLeft = getWizzyFilterPanel();
    if (!filtersLeft) return;
    var selected = getWizzySelectedFilters();
    var slot = ensureWizzyDesktopAppliedSlot(filtersLeft);
    var hasChips = !!(selected && selected.querySelector(".wizzy-selected-facet-list-item"));
    if (selected && selected.parentElement !== slot) {
        if (!selected.closest("[data-wizzy-desktop-applied]")) {
            wizzySelectedFiltersHome = { parent: selected.parentNode, next: selected.nextSibling };
        }
        slot.appendChild(selected);
    }
    slot.hidden = !hasChips;
    if (selected) syncWizzyDesktopPillRemove(selected);
    bindWizzyDesktopPillRemove();
    var clear = filtersLeft.querySelector(".wizzy-filters-header .wizzy-filters-clear-all");
    if (clear) clear.classList.toggle("wizzy-desktop-clear-visible", hasChips);
}

function getWizzyNativeApplyButton() {
    return document.querySelector(".wizzy-search-filters-left .wizzy-mobile-filter-buttons .wizzy-apply-all-button") || document.querySelector(".wizzy-apply-all-button");
}

function readWizzySummaryCount() {
    var summary = document.querySelector(".wizzy-summary-head");
    if (!summary) return "";
    var match = summary.textContent.replace(/\s+/g, " ").trim().match(/(\d[\d,]*)/);
    if (!match) return "";
    var count = match[1].replace(/,/g, "");
    return count + (count === "1" ? " product" : " products");
}

function syncWizzyFilterHeaderTitle() {
    var isMobile = window.innerWidth <= WIZZY_MOBILE_FILTER_MAX;
    var countText = isMobile ? readWizzySummaryCount() : "";
    document.querySelectorAll("p.header-title").forEach(function (title) {
        var label = title.textContent.trim().toLowerCase();
        if (label !== "filters" && label !== "filter and sort") return;
        title.textContent = isMobile ? "Filter and sort" : "Filters";
        var countEl = title.nextElementSibling;
        if (!isMobile) {
            if (countEl && countEl.classList.contains("mobile-facets__count")) countEl.remove();
            return;
        }
        if (!countEl || !countEl.classList.contains("mobile-facets__count")) {
            countEl = document.createElement("p");
            countEl.className = "mobile-facets__count";
            title.insertAdjacentElement("afterend", countEl);
        }
        countEl.textContent = countText;
    });
}

function wizzyPriceNumber(value) {
    var raw = String(value == null ? "" : value).replace(/[^\d.,]/g, "").replace(/^\.+/, "");
    if (raw === "") return null;
    var lastDot = raw.lastIndexOf(".");
    var lastComma = raw.lastIndexOf(",");
    if (lastComma > lastDot) {
        raw = raw.replace(/\./g, "").replace(",", ".");
    } else {
        raw = raw.replace(/,/g, "");
        var parts = raw.split(".");
        if (parts.length > 2) {
            var decimal = parts.pop();
            raw = parts.join("") + "." + decimal;
        }
    }
    var number = Number(raw);
    return isNaN(number) ? null : number;
}

function wizzyWholePrice(value) {
    var text = String(value == null ? "" : value)
        .replace(/[\u200E\u200F\u202A-\u202E\u2066-\u2069\u061C]/g, "")
        .replace(/د\s*\.?\s*إ/g, "")
        .replace(/درهم/g, "")
        .replace(/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/g, "")
        .replace(/\.(?!\d)/g, "");
    var number = wizzyPriceNumber(text);
    if (number == null) return "";
    return String(Math.round(number));
}

function showWizzyWholePrice(input) {
    if (!input || document.activeElement === input) return;
    var whole = wizzyWholePrice(input.value);
    if (!whole || input.value === whole) return;
    input.value = whole;
}

function wizzyIsSearchListing() {
    if (document.documentElement.classList.contains("wizzy-collection-query")) return true;
    if (document.body && document.body.classList.contains("wizzy-collection-query")) return true;
    return !document.getElementById("wizzy-shopify-collection-page-wrapper");
}

function wizzyShownPrice(input, bound) {
    if (document.activeElement === input) return;
    var whole = wizzyWholePrice(input.value);
    var boundWhole = wizzyWholePrice(bound);
    if (!whole || (boundWhole && whole === boundWhole)) {
        if (input.value !== "") input.value = "";
        return;
    }
    if (input.value !== whole) input.value = whole;
}

function wizzyIsPriceFacet(item) {
    var block = item.closest(".wizzy-filters-facet-block");
    var title = block && block.querySelector(".facet-head-title");
    var haystack = ((block && block.className) || "") + " " + (title ? title.textContent : "");
    return /price/i.test(haystack);
}

function ensureWizzyPriceLabel(input, text) {
    var wrap = input.parentElement;
    if (!wrap) return;
    wrap.classList.add("field");
    var label = wrap.querySelector(":scope > .field__label");
    if (!label) {
        label = document.createElement("label");
        label.className = "field__label";
        wrap.appendChild(label);
    }
    label.textContent = text;
    if (!input.id) input.id = "WizzyPrice" + text + Math.random().toString(36).slice(2, 8);
    label.setAttribute("for", input.id);
}

function isWizzyPriceAppliedChip(item) {
    var key = ((item.getAttribute("data-facetkey") || "") + " " + (item.getAttribute("data-key") || "")).toLowerCase();
    if (key.indexOf("price") !== -1) return true;
    return /د\s*\.?\s*إ|درهم|aed/i.test(item.textContent || "");
}

function cleanAppliedFilterText(text, isPrice) {
    var next = String(text)
        .replace(/د\s*\.?\s*إ/g, " ")
        .replace(/درهم/g, " ")
        .replace(/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/g, " ");
    if (isPrice) {
        next = next.replace(/(\d+)\.(\d{1,2})(?!\d)/g, function (_, whole, fraction) {
            return String(Math.round(Number(whole + "." + fraction)));
        });
    } else {
        next = next.replace(/(\d+)\.00(?!\d)/g, "$1");
    }
    next = next.replace(/(\d)\s*\.(?=\s|$|-)/g, "$1").replace(/[ \t]{2,}/g, " ");
    if (isPrice && /\d/.test(next) && !/AED/i.test(next)) {
        next = next.replace(/(\d+)/g, "AED $1");
    }
    return next;
}

function cleanWizzyAppliedFilters() {
    document.querySelectorAll(".wizzy-selected-facet-list-item").forEach(function (item) {
        var isPrice = isWizzyPriceAppliedChip(item);
        var walker = document.createTreeWalker(item, NodeFilter.SHOW_TEXT, {
            acceptNode: function (node) {
                if (!node.parentElement || node.parentElement.closest(".wizzy-selected-facet-delete")) {
                    return NodeFilter.FILTER_REJECT;
                }
                return NodeFilter.FILTER_ACCEPT;
            }
        });
        var node;
        while ((node = walker.nextNode())) {
            var next = cleanAppliedFilterText(node.nodeValue, isPrice);
            if (next !== node.nodeValue) node.nodeValue = next;
        }
    });
}

function syncWizzyPriceInputs() {
    document.querySelectorAll(".wizzy-search-wrapper .facet-range-item").forEach(function (item) {
        var isPrice = wizzyIsPriceFacet(item);
        var slider = item.querySelector(".wizzy-facet-range-slider");
        var minInput = item.querySelector(".wizzy-range-min");
        var maxInput = item.querySelector(".wizzy-range-max");
        var inputs = item.querySelector(".wizzy-facet-range-inputs");
        var maxValue = slider && slider.getAttribute("data-max");
        var maxPrice = maxValue ? (wizzyWholePrice(maxValue) || maxValue) : "";
        if (minInput && isPrice) {
            minInput.placeholder = "0";
            ensureWizzyPriceLabel(minInput, "From");
            showWizzyWholePrice(minInput);
        }
        if (maxInput && isPrice) {
            maxInput.placeholder = maxPrice || "0";
            ensureWizzyPriceLabel(maxInput, "To");
            showWizzyWholePrice(maxInput);
        }
        if (isPrice && slider && slider.noUiSlider && !slider.dataset.wizzyWholePriceBound) {
            slider.dataset.wizzyWholePriceBound = "1";
            slider.noUiSlider.on("update", function () {
                showWizzyWholePrice(minInput);
                showWizzyWholePrice(maxInput);
                window.setTimeout(function () {
                    showWizzyWholePrice(minInput);
                    showWizzyWholePrice(maxInput);
                }, 0);
            });
        }
        if (!isPrice) {
            item.querySelectorAll(".field__label, .wizzy-range-input-currency, .wizzy-price-max-note").forEach(function (node) {
                node.remove();
            });
            return;
        }
        if (!maxPrice) return;
        var note = item.querySelector(".wizzy-price-max-note");
        if (!note) {
            note = document.createElement("p");
            note.className = "wizzy-price-max-note";
            if (inputs) item.insertBefore(note, inputs);
            else item.appendChild(note);
        }
        note.textContent = "The highest price is " + maxPrice + " AED";
        var mark = inputs && inputs.querySelector(":scope > .wizzy-range-input-currency");
        if (inputs) {
            if (!mark) {
                mark = document.createElement("span");
                mark.className = "field-currency wizzy-range-input-currency";
                inputs.insertBefore(mark, inputs.firstChild);
            }
            mark.textContent = "AED";
        }
        item.querySelectorAll(".wizzy-range-input-wrapper .wizzy-range-input-currency").forEach(function (node) {
            node.remove();
        });
    });
}

function bindWizzyPriceInputApply() {
    if (window._wizzyPriceInputApply) return;
    window._wizzyPriceInputApply = true;
    document.addEventListener("change", function (event) {
        var input = event.target;
        if (!input || !input.classList) return;
        if (!input.classList.contains("wizzy-range-min") && !input.classList.contains("wizzy-range-max")) return;
        var item = input.closest(".facet-range-item");
        if (!item) return;
        var whole = wizzyWholePrice(input.value);
        if (whole) input.value = whole;
    }, true);
    document.addEventListener("keydown", function (event) {
        if (event.key !== "Enter") return;
        var input = event.target;
        if (!input || !input.classList) return;
        if (!input.classList.contains("wizzy-range-min") && !input.classList.contains("wizzy-range-max")) return;
        event.preventDefault();
        var whole = wizzyWholePrice(input.value);
        if (whole) input.value = whole;
        input.dispatchEvent(new Event("change", { bubbles: true }));
    });
}

bindWizzyPriceInputApply();

function syncWizzyMobileFooter() {
    var clearButton = document.querySelector(".wizzy-search-filters-left .wizzy-mobile-filter-clear");
    if (!clearButton) return;
    var openBody = document.querySelector(".wizzy-search-filters-left .wizzy-facet-body.wizzy-selected-facet-body");
    clearButton.textContent = openBody ? "Clear" : "Remove all";
    clearButton.dataset.mode = openBody ? "facet" : "all";
}

var wizzySortHome = null;

function parkWizzyMobileSort(listBlock) {
    if (window.innerWidth > 768) return;
    var sort = document.querySelector(".wizzy-search-wrapper .wizzy-search-sort-wrapper:not(.wizzy-mobile-sort-copy)");
    if (!sort || !listBlock || sort.closest(".wizzy-facet-list-block")) return;
    var existing = listBlock.querySelector(".wizzy-search-sort-wrapper.wizzy-mobile-sort-copy");
    if (existing) existing.remove();
    var copy = sort.cloneNode(true);
    copy.classList.add("wizzy-mobile-sort-copy");
    copy.setAttribute("data-wizzy-mobile-ui", "1");
    listBlock.appendChild(copy);
    copy.addEventListener("click", function (e) {
        var option = e.target.closest(".wizzy-common-select-option");
        if (!option) return;
        e.preventDefault();
        e.stopPropagation();
        var label = (option.getAttribute("title") || option.textContent || "").trim();
        var originalOptions = sort.querySelectorAll(".wizzy-common-select-option");
        for (var i = 0; i < originalOptions.length; i++) {
            var text = (originalOptions[i].getAttribute("title") || originalOptions[i].textContent || "").trim();
            if (text === label) {
                originalOptions[i].click();
                break;
            }
        }
    });
    var copySelect = copy.querySelector("select");
    var originalSelect = sort.querySelector("select");
    if (copySelect && originalSelect) {
        copySelect.addEventListener("change", function () {
            originalSelect.value = copySelect.value;
            originalSelect.dispatchEvent(new Event("change", { bubbles: true }));
        });
    }
}

function restoreWizzyMobileSort() {
    document.querySelectorAll(".wizzy-search-sort-wrapper.wizzy-mobile-sort-copy").forEach(function (node) {
        node.remove();
    });
    var sort = document.querySelector(".wizzy-search-wrapper .wizzy-search-sort-wrapper:not(.wizzy-mobile-sort-copy)");
    var placeholder = document.querySelector(".wizzy-sort-placeholder");
    if (sort && placeholder && placeholder.parentNode && sort.closest(".wizzy-facet-list-block")) {
        placeholder.parentNode.insertBefore(sort, placeholder.nextSibling);
    }
    if (placeholder) placeholder.remove();
    wizzySortHome = null;
}

function ensureWizzyFacetBack(body, head) {
    var title = head && head.querySelector(".facet-head-title");
    var label = title ? title.textContent.trim() : "";
    var back = body.querySelector(".wizzy-mobile-facet-back");
    if (!back) {
        back = document.createElement("button");
        back.type = "button";
        back.className = "mobile-facets__close-button link link--text focus-inset wizzy-mobile-facet-back";
        back.setAttribute("data-wizzy-mobile-ui", "1");
        back.innerHTML = WIZZY_ARROW_SVG + "<span></span>";
        body.insertBefore(back, body.firstChild);
    }
    var text = back.querySelector("span");
    if (text) text.textContent = label;
}

function enhanceWizzyMobileDrawer() {
    if (!wizzyMobileFilterViewport() || !wizzyMobileOverlayOpen()) return;
    var panel = getWizzyFilterPanel();
    if (!panel) return;
    var wrapper = panel.querySelector(".wizzy-search-filters-left-wrapper");
    if (!wrapper) return;

    wrapper.classList.add("mobile-facets__inner");

    var header = wrapper.querySelector(".wizzy-filters-header");
    if (!header) {
        header = document.createElement("div");
        header.className = "wizzy-filters-header";
        wrapper.insertBefore(header, wrapper.firstChild);
    }
    header.classList.add("mobile-facets__header");
    var injectedHeading = header.querySelector(".wizzy-mobile-filter-heading");
    if (injectedHeading) injectedHeading.remove();
    syncWizzyFilterHeaderTitle();
    var nativeClose = panel.querySelector(".wizzy-filters-close-btn") || document.querySelector(".wizzy-filters-close-btn");
    if (!nativeClose) {
        nativeClose = document.createElement("button");
        nativeClose.type = "button";
        nativeClose.className = "wizzy-filters-close-btn";
        nativeClose.setAttribute("aria-label", "Close");
    }
    if (nativeClose.parentElement !== header) header.appendChild(nativeClose);
    var customClose = header.querySelector(".wizzy-mobile-drawer-close");
    if (customClose) customClose.remove();

    var listBlock = wrapper.querySelector(".wizzy-facet-list-block");
    if (!listBlock) {
        listBlock = document.createElement("div");
        listBlock.className = "wizzy-facet-list-block";
        listBlock.setAttribute("data-wizzy-created-list", "1");
        var blocks = wrapper.querySelectorAll(".wizzy-filters-facet-block");
        if (!blocks.length) return;
        blocks[0].parentNode.insertBefore(listBlock, blocks[0]);
        blocks.forEach(function (block) {
            listBlock.appendChild(block);
        });
    }
    listBlock.classList.add("mobile-facets__main");
    parkWizzyMobileSort(listBlock);

    wrapper.querySelectorAll(".wizzy-filters-facet-block").forEach(function (block) {
        var head = block.querySelector(".wizzy-facet-head");
        var body = block.querySelector(".wizzy-facet-body");
        if (head) {
            head.classList.add("mobile-facets__summary");
            if (!head.querySelector(".wizzy-mobile-facet-arrow")) {
                var arrow = document.createElement("span");
                arrow.className = "mobile-facets__arrow wizzy-mobile-facet-arrow";
                arrow.setAttribute("data-wizzy-mobile-ui", "1");
                arrow.innerHTML = WIZZY_ARROW_SVG;
                head.appendChild(arrow);
            }
        }
        if (body) {
            body.classList.add("mobile-facets__submenu");
            if (head) ensureWizzyFacetBack(body, head);
        }
    });

    if (!wrapper.querySelector(".wizzy-mobile-filter-footer")) {
        var footer = document.createElement("div");
        footer.className = "mobile-facets__footer wizzy-mobile-filter-footer";
        footer.setAttribute("data-wizzy-mobile-ui", "1");
        footer.innerHTML = '<button type="button" class="mobile-facets__clear underlined-link wizzy-mobile-filter-clear">Remove all</button><button type="button" class="button button--primary wizzy-mobile-filter-apply">Apply</button>';
        wrapper.appendChild(footer);
    }
    syncWizzyMobileFooter();
}

function teardownWizzyMobileDrawer() {
    restoreWizzyMobileSort();
    var createdList = document.querySelector(".wizzy-search-filters-left .wizzy-facet-list-block[data-wizzy-created-list]");
    if (createdList && createdList.parentNode) {
        while (createdList.firstChild) {
            createdList.parentNode.insertBefore(createdList.firstChild, createdList);
        }
        createdList.remove();
    }
    document.querySelectorAll(".wizzy-search-filters-left [data-wizzy-mobile-ui]").forEach(function (node) {
        node.remove();
    });
    document.querySelectorAll(".wizzy-search-filters-left .mobile-facets__inner, .wizzy-search-filters-left .mobile-facets__header, .wizzy-search-filters-left .mobile-facets__main, .wizzy-search-filters-left .mobile-facets__summary, .wizzy-search-filters-left .mobile-facets__submenu").forEach(function (node) {
        node.classList.remove("mobile-facets__inner", "mobile-facets__header", "mobile-facets__main", "mobile-facets__summary", "mobile-facets__submenu");
    });
    clearMobileFacetSlide();
}

function clickWizzyFiltersOverlay() {
    var overlay = document.querySelector(".wizzy-filters-bg");
    if (overlay) overlay.click();
}

function clearMobileFacetSlide() {
    document.querySelectorAll(".wizzy-facet-head.wizzy-selected-facet, .wizzy-facet-body.wizzy-selected-facet-body").forEach(function (el) {
        el.classList.remove("wizzy-selected-facet", "wizzy-selected-facet-body");
    });
}

function openMobileFacetSlide(head) {
    var block = head && head.closest(".wizzy-filters-facet-block");
    var body = block && block.querySelector(".wizzy-facet-body");
    if (!body) return;

    document.querySelectorAll(".wizzy-search-filters-left .wizzy-facet-head.wizzy-selected-facet").forEach(function (el) {
        if (el !== head) el.classList.remove("wizzy-selected-facet");
    });
    document.querySelectorAll(".wizzy-search-filters-left .wizzy-facet-body.wizzy-selected-facet-body").forEach(function (el) {
        if (el !== body) el.classList.remove("wizzy-selected-facet-body");
    });

    head.classList.add("wizzy-selected-facet");
    body.classList.add("wizzy-selected-facet-body");
    body.style.removeProperty("display");
    ensureWizzyFacetBack(body, head);
    syncWizzyMobileFooter();
}

function bindWizzyMobileInnerApplyButton() {
    if (window._wizzyMobileApplyCloseBound) return;
    window._wizzyMobileApplyCloseBound = true;
    document.addEventListener("click", function (e) {
        if (!e.target || !e.target.closest) return;
        var innerApplyButton = e.target.closest(".wz-filter-apply-sub-button");
        if (!innerApplyButton) return;
        var applyButton = getWizzyNativeApplyButton();
        if (applyButton) applyButton.click();
    });
}

function bindWizzyMobileCloseSvgClose() {
    if (window._wizzyMobileSvgCloseBound) return;
    window._wizzyMobileSvgCloseBound = true;
    document.addEventListener("click", function (e) {
        if (!e.target || !e.target.closest) return;
        var svgButton = e.target.closest(".wizzy-overlay-opened.wizzy-filters-overlay .wizzy-search-filters-left button.mobile-facets__close-button .mobile-facets__close, .wizzy-overlay-opened.wizzy-filters-overlay .wizzy-search-filters-left .wizzy-filters-close-btn, .wizzy-overlay-opened.wizzy-filters-overlay .wizzy-filters-bg");
        if (!svgButton) return;
        clearMobileFacetSlide();
        if (!svgButton.classList.contains("wizzy-filters-bg")) clickWizzyFiltersOverlay();
    });
}

function bindWizzySubClearFilterButton() {
    if (window._wizzySubClearFilterBound) return;
    window._wizzySubClearFilterBound = true;
    document.addEventListener("click", function (e) {
        if (!e.target || !e.target.closest) return;
        var innerSubClearButton = e.target.closest(".wz-sub-clear-filter-button");
        if (!innerSubClearButton) return;
        e.preventDefault();
        var facetBody = innerSubClearButton.closest(".wizzy-facet-body");
        if (!facetBody) return;
        facetBody.querySelectorAll(".wizzy-facet-list-item.active, .wizzy-facet-list-item.selected").forEach(function (item) {
            item.click();
        });
        var applyButton = facetBody.querySelector(".wz-filter-apply-sub-button");
        if (applyButton) applyButton.click();
    });
}

function bindWizzyMobileFacetBackButton() {
    if (window._wizzyMobileFacetBackBound) return;
    window._wizzyMobileFacetBackBound = true;
    document.addEventListener("click", function (e) {
        if (!e.target || !e.target.closest) return;
        var simpleBack = e.target.closest(".wizzy-mobile-facet-back");
        if (!simpleBack) return;
        e.preventDefault();
        e.stopPropagation();
        var facetBody = simpleBack.closest(".wizzy-facet-body");
        var selectedFacetHead = facetBody && facetBody.parentElement && facetBody.parentElement.querySelector(".wizzy-facet-head");
        if (selectedFacetHead) selectedFacetHead.classList.remove("wizzy-selected-facet");
        if (facetBody) {
            facetBody.classList.remove("wizzy-selected-facet-body");
            facetBody.style.display = "none";
        }
        syncWizzyMobileFooter();
    });
}

function bindWizzyMobileFacetHeaderClose() {
    if (window._wizzyMobileFacetCloseOnBackAndCloseButtonBound) return;
    window._wizzyMobileFacetCloseOnBackAndCloseButtonBound = true;
    document.addEventListener("click", function (e) {
        if (!e.target || !e.target.closest) return;
        var svgButton = e.target.closest(".wizzy-overlay-opened.wizzy-filters-overlay .wizzy-search-filters-left .wizzy-filters-header .mobile-facets__close");
        if (!svgButton) return;
        clearMobileFacetSlide();
        clickWizzyFiltersOverlay();
    });
}

function bindWizzyMobileFacetClearAllFilters() {
    if (window._wizzyMobileFacetClearAllFiltersBound) return;
    window._wizzyMobileFacetClearAllFiltersBound = true;
    document.addEventListener("click", function (e) {
        if (!e.target || !e.target.closest) return;
        var clearAllFiltersButton = e.target.closest(".wizzy-overlay-opened.wizzy-filters-overlay .wizzy-search-filters-left .wz-clear-all-filter-button");
        if (!clearAllFiltersButton) return;
        var actualClearAllButton = document.querySelector(".wizzy-filters-clear-all");
        if (actualClearAllButton) actualClearAllButton.click();
        else clickWizzyFiltersOverlay();
    });
}

function bindWizzyMobileFacetSlide() {
    if (window._wizzyMobileFacetSlideBound) return;
    window._wizzyMobileFacetSlideBound = true;
    document.addEventListener("click", function (e) {
        if (window.innerWidth > 768 || !e.target || !e.target.closest) return;
        if (e.target.closest(".wizzy-mobile-facet-back, .wizzy-mobile-filter-footer, .wizzy-mobile-drawer-close")) return;
        var head = e.target.closest(".wizzy-overlay-opened.wizzy-filters-overlay .wizzy-search-filters-left .wizzy-facet-head");
        if (!head) return;
        enhanceWizzyMobileDrawer();
        openMobileFacetSlide(head);
    }, true);
}

function bindWizzyMobileDrawerFooter() {
    if (window._wizzyMobileDrawerFooterBound) return;
    window._wizzyMobileDrawerFooterBound = true;
    document.addEventListener("click", function (e) {
        if (!e.target || !e.target.closest) return;
        var clearButton = e.target.closest(".wizzy-mobile-filter-clear");
        var applyButton = e.target.closest(".wizzy-mobile-filter-apply");
        if (!clearButton && !applyButton) return;
        e.preventDefault();
        e.stopPropagation();
        if (clearButton) {
            if (clearButton.dataset.mode === "facet") {
                var body = document.querySelector(".wizzy-search-filters-left .wizzy-facet-body.wizzy-selected-facet-body");
                if (body) {
                    body.querySelectorAll(".wizzy-facet-list-item.active, .wizzy-facet-list-item.selected").forEach(function (item) {
                        item.click();
                    });
                }
            } else {
                var actualClearAllButton = document.querySelector(".wizzy-filters-clear-all");
                if (actualClearAllButton) actualClearAllButton.click();
            }
            return;
        }
        var nativeApply = getWizzyNativeApplyButton();
        if (nativeApply) nativeApply.click();
        window.setTimeout(function () {
            clearMobileFacetSlide();
            clickWizzyFiltersOverlay();
        }, 0);
    });
}

function watchWizzyMobileOverlay() {
    if (window._wizzyMobileOverlayWatch) return;
    window._wizzyMobileOverlayWatch = true;
    var sync = function () {
        syncWizzyFilterHeaderTitle();
        placeWizzyDesktopAppliedFilters();
        if (!wizzyMobileFilterViewport() || !wizzyMobileOverlayOpen()) {
            teardownWizzyMobileDrawer();
            return;
        }
        enhanceWizzyMobileDrawer();
    };
    var observer = new MutationObserver(sync);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    if (document.body) observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    document.addEventListener("click", function (e) {
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest(".wizzy-filters-mobile-entry, .wizzy-search-filters-drawer-button, .wizzy-filters-button")) return;
        window.setTimeout(sync, 0);
        window.setTimeout(sync, 80);
    });
    window.addEventListener("resize", sync);
}

function bindWizzyMobileFilterBehaviour() {
    bindWizzyMobileInnerApplyButton();
    bindWizzyMobileCloseSvgClose();
    bindWizzySubClearFilterButton();
    bindWizzyMobileFacetBackButton();
    bindWizzyMobileFacetHeaderClose();
    bindWizzyMobileFacetClearAllFilters();
    bindWizzyMobileFacetSlide();
    bindWizzyMobileDrawerFooter();
    watchWizzyMobileOverlay();
}

bindWizzyMobileFilterBehaviour();

function wizzyDesktopSortOptions() {
    if (window.innerWidth <= 768) return null;
    return document.querySelector(".wizzy-search-wrapper .wizzy-search-filters-top .wizzy-search-sort-wrapper:not(.wizzy-mobile-sort-copy) .wizzy-common-select-options");
}

function wizzyDesktopSortIsOpen() {
    var options = wizzyDesktopSortOptions();
    if (!options) return false;
    return window.getComputedStyle(options).display !== "none";
}

function syncDesktopSortOverlay() {
    var open = wizzyDesktopSortIsOpen();
    [document.documentElement, document.body].forEach(function (el) {
        if (!el) return;
        el.classList.toggle("wizzy-common-select-body-overlay", open);
        if (open) {
            el.classList.add("wizzy-overlay-opened");
        } else if (!el.classList.contains("wizzy-filters-overlay")) {
            el.classList.remove("wizzy-overlay-opened");
        }
    });
}

function bindDesktopSortOverlay() {
    if (window._wizzyDesktopSortOverlay) return;
    window._wizzyDesktopSortOverlay = true;
    var sync = function () {
        window.setTimeout(syncDesktopSortOverlay, 0);
    };
    document.addEventListener("click", sync);
    document.addEventListener("mouseup", sync);
}

bindDesktopSortOverlay();

function setWizzyAutocompleteEngaged(engaged) {
    window._wizzyAutocompleteEngaged = !!engaged;
    if (document.documentElement) {
        document.documentElement.classList.toggle("wizzy-autocomplete-engaged", !!engaged);
    }
}

function hideSearchAutocompletePanel() {
    window._wizzyAutocompleteForceClosed = true;
    setWizzyAutocompleteEngaged(false);
    document.querySelectorAll(".wizzy-autocomplete-wrapper").forEach(function (wrapper) {
        wrapper.classList.add("wizzy-autocomplete-closed");
        wrapper.style.setProperty("display", "none", "important");
        wrapper.setAttribute("aria-hidden", "true");
    });
}

function closeSearchAutocomplete() {
    hideSearchAutocompletePanel();
    document.querySelectorAll(".header__search details[open]").forEach(function (details) {
        details.removeAttribute("open");
    });
    if (document.activeElement && document.activeElement.blur && document.activeElement.closest && document.activeElement.closest(".header__search, .search-modal")) {
        document.activeElement.blur();
    }
}

function isSearchInputActive() {
    if (window._wizzyAutocompleteEngaged) return true;
    var active = document.activeElement;
    if (active && active.closest) {
        if (active.closest(".header__search .search__input, .search-modal .search__input, .template-search .search__input")) {
            return true;
        }
        if (active.closest(".wizzy-autocomplete-wrapper")) {
            return true;
        }
    }
    return !!document.querySelector(".header__search details[open] .search__input:focus, .search-modal .search__input:focus, .template-search .search__input:focus");
}

function releaseSearchAutocomplete() {
    if (!document.querySelector(".header__search details[open]") && !isSearchInputActive()) {
        hideSearchAutocompletePanel();
        return;
    }
    window._wizzyAutocompleteForceClosed = false;
    document.querySelectorAll(".wizzy-autocomplete-wrapper").forEach(function (wrapper) {
        wrapper.classList.remove("wizzy-autocomplete-closed");
        wrapper.style.removeProperty("display");
        wrapper.removeAttribute("aria-hidden");
    });
}

function bindSearchAutocompleteClose() {
    if (window._wizzySearchAutocompleteCloseBound) return;
    window._wizzySearchAutocompleteCloseBound = true;
    document.addEventListener(
        "submit",
        function (event) {
            var form = event.target;
            if (!form || !form.closest) return;
            if (!form.closest(".header__search, .search-modal, search-form, .search-modal__form, form[action*='/search']")) return;
            closeSearchAutocomplete();
            window.setTimeout(closeSearchAutocomplete, 0);
            window.setTimeout(closeSearchAutocomplete, 200);
        },
        true
    );
    document.addEventListener(
        "click",
        function (event) {
            if (!event.target || !event.target.closest) return;
            if (!event.target.closest(".header__search .search__button, .search-modal .search__button")) return;
            closeSearchAutocomplete();
        },
        true
    );
}

function syncAutocompleteWidth() {
    if (window.innerWidth < 750) return;

    var searchBar = document.querySelector(".header__search details[open] .search-modal__content .search__input")
        || document.querySelector(".search-modal__content #Search-In-Modal")
        || document.querySelector(".search-modal__content #Search-In-Modal-1");
    var autoComplete = document.querySelector(".wizzy-autocomplete-wrapper");
    if (!searchBar || !autoComplete) return;

    autoComplete.style.setProperty("transform", "none", "important");

    var searchRect = searchBar.getBoundingClientRect();
    var autoRect = autoComplete.getBoundingClientRect();
    var shift = (searchRect.left + (searchRect.width / 2)) - (autoRect.left + (autoRect.width / 2));

    autoComplete.style.setProperty("transform", "translateX(" + shift + "px)", "important");
}

function bindAutocompleteCenter() {
    if (window._wizzyAutocompleteCenter) return;
    window._wizzyAutocompleteCenter = true;
    var sync = function () {
        window.setTimeout(syncAutocompleteWidth, 100);
    };
    document.addEventListener("click", function (event) {
        if (!event.target || !event.target.closest) return;
        if (!event.target.closest(".search__input")) return;
        if (event.target.closest(".header__search") && !document.querySelector(".header__search details[open]")) return;
        releaseSearchAutocomplete();
        if (event.target.closest(".header__search .search__input")) sync();
    });
    document.addEventListener("input", function (event) {
        if (!event.target || !event.target.closest) return;
        if (!event.target.closest(".search__input")) return;
        if (event.target.closest(".header__search") && !document.querySelector(".header__search details[open]")) return;
        releaseSearchAutocomplete();
        if (event.target.closest(".header__search .search__input")) sync();
    });
    document.addEventListener("focusin", function (event) {
        if (!event.target || !event.target.closest) return;
        if (!event.target.closest(".header__search .search__input, .search-modal .search__input, .template-search .search__input")) return;
        if (event.target.closest(".header__search") && !document.querySelector(".header__search details[open]")) return;
        releaseSearchAutocomplete();
        if (event.target.closest(".header__search .search__input")) sync();
    });
    window.addEventListener("resize", sync);
}

function bindSearchAutocompleteInactiveClose() {
    if (window._wizzySearchAutocompleteInactiveBound) return;
    window._wizzySearchAutocompleteInactiveBound = true;

    function isAutocompleteTarget(event) {
        return !!(event.target && event.target.closest && event.target.closest(".wizzy-autocomplete-wrapper"));
    }

    document.addEventListener("mousedown", function (event) {
        if (!isAutocompleteTarget(event)) return;
        setWizzyAutocompleteEngaged(true);
    });
    document.addEventListener("mouseup", function () {
        window.setTimeout(function () {
            setWizzyAutocompleteEngaged(false);
        }, 0);
    });

    function isWizzyAutocompleteActionClick(event) {
        if (!event.target || !event.target.closest) return false;
        return !!event.target.closest(
            ".autocomplete-link, .wizzy-autocomplete-top-products-view-more, " +
                ".wizzy-recent-search-clear-all, .wizzy-recent-search-clear-icon, " +
                ".topproduct-item, .topproduct-item-link"
        );
    }

    /* Block theme details-modal outside-click on autocomplete chrome only; Wizzy binds body handlers later for links */
    document.body.addEventListener("click", function (event) {
        if (!isAutocompleteTarget(event)) return;
        if (isWizzyAutocompleteActionClick(event)) return;
        event.stopImmediatePropagation();
    }, false);

    document.addEventListener("focusout", function (event) {
        if (!event.target || !event.target.closest) return;
        if (!event.target.closest(".header__search .search__input, .search-modal .search__input, .template-search .search__input")) return;
        var related = event.relatedTarget;
        if (related && related.closest && related.closest(".wizzy-autocomplete-wrapper")) return;
        window.setTimeout(function () {
            if (window._wizzyAutocompleteEngaged) return;
            if (isSearchInputActive()) return;
            hideSearchAutocompletePanel();
        }, 150);
    });

    document.addEventListener("toggle", function (event) {
        var details = event.target;
        if (!details || !details.closest || !details.closest(".header__search")) return;
        if (!details.hasAttribute("open")) hideSearchAutocompletePanel();
    }, true);

    document.addEventListener(
        "click",
        function (event) {
            if (!event.target || !event.target.closest) return;
            if (event.target.closest(".header__search, .search-modal, .wizzy-autocomplete-wrapper")) return;
            if (!document.querySelector(".wizzy-autocomplete-wrapper:not(.wizzy-autocomplete-closed)")) return;
            if (isSearchInputActive()) return;
            hideSearchAutocompletePanel();
        },
        true
    );
}

function getWizzyAutocompleteSearchInput() {
    return (
        document.querySelector(".header__search details[open] .search__input") ||
        document.querySelector(".search-modal .search__input") ||
        document.querySelector(".template-search .search__input") ||
        document.querySelector(".wizzy-search-input") ||
        document.querySelector('.search__input[name="q"]')
    );
}

function bindAutocompleteViewAllSearch() {
    if (window._wizzyViewAllSearchBound) return;
    window._wizzyViewAllSearchBound = true;
    document.addEventListener(
        "click",
        function (event) {
            if (!event.target || !event.target.closest) return;
            if (!event.target.closest(".wizzy-autocomplete-top-products-view-more")) return;
            var input = getWizzyAutocompleteSearchInput();
            var form = input && input.closest ? input.closest("form") : null;
            if (!form) return;
            event.preventDefault();
            event.stopPropagation();
            if (typeof form.requestSubmit === "function") {
                form.requestSubmit();
            } else {
                form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
            }
        },
        true
    );
}

bindAutocompleteCenter();
bindSearchAutocompleteClose();
bindAutocompleteViewAllSearch();
if (document.body) {
    bindSearchAutocompleteInactiveClose();
} else {
    document.addEventListener("DOMContentLoaded", bindSearchAutocompleteInactiveClose);
}

function focusHeaderWizzySearchInput(root) {
    var scope = root && root.querySelector ? root : document;
    var input = scope.querySelector(".search__input.field__input");
    if (!input) return;
    input.focus();
    input.click();
}

document.addEventListener("click", function (event) {
    if (!event.target || !event.target.closest) return;
    var searchRoot = event.target.closest(".header__search");
    if (!searchRoot) return;
    if (event.target.closest(".search__input, .search-modal__close-button, .reset__button, .search__button")) return;
    window.setTimeout(function () {
        focusHeaderWizzySearchInput(searchRoot);
    }, 200);
});